import Toolbar from "@/components/Toolbar";
import VueUeditorWrap from "@/components/vue-ueditor-wrap";
import LangTabs from "@/components/LangTabs";
import SearchKoipyUser from "@/components/SearchKoipyUser";
function plugin(Vue) {
    if (plugin.installed) {
        return;
    }
    Vue.component("Toolbar", Toolbar);
    Vue.component("VueUeditorWrap", VueUeditorWrap);
    Vue.component("LangTabs", LangTabs);
    Vue.component("SearchKoipyUser", SearchKoipyUser);
}

export default plugin